import { IChartData } from '@ankr.com/telemetry';
import { createContext } from 'react';

import { CountriesCountsMap } from 'modules/stats/types';

export interface StatsContextValue {
  countries: CountriesCountsMap;
  countriesByTraffic: CountriesCountsMap;
  loading: boolean;
  requestsChartData: IChartData[];
  totalBytes: number;
  totalRequests: number;
  trafficChartData: IChartData[];
}

const defaultValue: StatsContextValue = {
  countries: {},
  countriesByTraffic: {},
  loading: false,
  requestsChartData: [],
  totalBytes: 0,
  totalRequests: 0,
  trafficChartData: [],
};

export const StatsContext = createContext(defaultValue);
